export default {
  iconTextInline: {
    display: 'flex',
    alignItems: 'center',
  },
  helpIcon: {
    marginLeft: 8,
    fontSize: 16,
  },
};
